import React from 'react'
import DOMPurify from 'dompurify'
import { useSelector } from 'react-redux'

import _ from 'lodash'

import { getExternalLinks } from 'stores/Links/Select'

import {
  Container,
  Segment
} from 'semantic-ui-react'

import { getCurrentYear } from '@web/helpers/getCurrentYear'

import { useTheme } from 'contexts/ThemeProvider'
import themeStyles from 'components/Footer/styles'

const URL_LIST = [
  { label: 'Español', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Spanish' },
  { label: '繁體中文', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Chinese' },
  { label: 'Tiếng Việt', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Vietnamese' },
  { label: 'Tagalog', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Tagalog' },
  { label: '한국어', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Korean' },
  { label: 'Հայերեն', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Armenian' },
  { label: 'فارسی', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Farsi' },
  { label: 'Русский', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Russian' },
  { label: '日本語', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Japanese' },
  { label: 'العربية', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Arabic' },
  { label: 'ਪੰਜਾਬੀ', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Punjabi' },
  { label: 'ខ្មែរ', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Cambodian' },
  { label: 'Hmoob', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Hmong' },
  { label: 'हिंदी', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Hindi' },
  { label: 'ภาษาไทย', url: 'https://www.choc.org/about/policies-legal/notice-of-nondiscrimination/#Thai' }
]
const CONFIG = {
  ADD_ATTR: ['target']
};

function SafetyFooter() {
  const links = _.merge({}, ...Object.values(useSelector(getExternalLinks)))
  const currentYear = getCurrentYear()
  const footerContent = _.get(links, 'UFD_Dynamic_Footer_Content', '')
  const updatedContent = footerContent.replace(/©\s*\d{4}/g, `©${currentYear}`)
  const styleMatch = !_.isEmpty(updatedContent) && updatedContent.match(/<style[^>]*>[\s\S]*?<\/style>/gi)
  const stylesTag = styleMatch ? styleMatch.join('') : ''
  const clean = DOMPurify.sanitize(updatedContent, CONFIG);
  return <div dangerouslySetInnerHTML={{ __html: clean + stylesTag }} />
}

export default function DefaultFooter() {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const links = _.merge({}, ...Object.values(useSelector(getExternalLinks)))
  const currentYear = getCurrentYear()
  return (
    <Segment inverted vertical style={styles.segment}>
      <Container style={styles.container}>
        {_.isEmpty(_.get(links, 'UFD_Dynamic_Footer_Content'))
          ? <div style={styles.text}>
              <p className="footerUrls" style={styles.text}>Language Assistance:&nbsp;
                {URL_LIST.map((item, index) => (<a style={styles.text} key={index} href={item.url} target="_blank" rel="noreferrer">{item.label}</a>))}
              </p>
              <p style={styles.footerLineText}>{currentYear}&nbsp;CHOC&nbsp;1201&nbsp;W&nbsp;La&nbsp;Veta&nbsp;Ave,&nbsp;Orange,&nbsp;CA&nbsp;92868&nbsp;&nbsp;|&nbsp;&nbsp;Phone:&nbsp;714-203-2181&nbsp;&nbsp;|&nbsp;&nbsp;<a href="https://www.choc.org" target="_blank" rel="noreferrer">www.choc.org</a>&nbsp;&nbsp;|&nbsp;&nbsp;A&nbsp;501 &nbsp;(c)&nbsp;(3)&nbsp;&nbsp;Organization</p>
            </div>
          : <SafetyFooter />
        }
      </Container>
    </Segment>
  )
}
